/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  width: 'max-content',
  borderRadius: '8px',
  background: theme.palette.semantic_dark?.surface.inverseSurface,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(1),
}));

export const BubbleBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const HeadingBox = styled(Box)(({theme}) => ({
  padding: theme.spacing(1),
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'baseline',
}));

export const HeadingText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_light?.surface.onSurface,
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '20px',
}));

export const HeadingSubText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_light?.surface.onSurface,
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '14px',
}));
